import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHandlerService } from './http-handler.service';
import { IUserMyProfile } from '../models/user-profile';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  private http = inject(HttpHandlerService);

  getMyProfile(): Observable<IUserMyProfile> {
    return this.http.get<IUserMyProfile>('User/GetMyProfile');
  }
}
